<template>
  <main class="school-page">
    <gym-banner />

    <main-certificate />

    <school-new-schedule active-prof-class="gym" />

    <school-what-benefit />

    <school-new-quality have-small-text />

    <school-tariffs />

    <main-care />

    <su-reviews />

    <school-another-ways />

    <su-form />

    <olga-block />

    <su-faq />

    <main-necessary />

    <school-new-breadcrumbs :breadcrumbs="breadcrumbs" />
  </main>
</template>

<script>
import HeadMixin from '@/mixins/HeadMixin';

import SuReviews from '../../../components/v2/school-university/SuReviews.vue';
import MainNecessary from '../../../components/v2/main/MainNecessary.vue';
import SuFaq from '../../../components/v2/school-university/SuFaq.vue';
import SchoolNewSchedule from '../../../components/v2/school-new/SchoolNewSchedule.vue';
import SchoolNewQuality from '../../../components/v2/school-new/SchoolNewQuality.vue';
import SchoolNewBreadcrumbs from '../../../components/v2/school-new/SchoolNewBreadcrumbs.vue';
import MainCare from '../../../components/v2/main/MainCare.vue';
import SuForm from '../../../components/v2/school-university/SuForm.vue';
import GymBanner from '../../../components/v2/school-new/GymBanner.vue';
import SchoolAnotherWays from '../../../components/v2/school-new/SchoolAnotherWays.vue';
import SchoolWhatBenefit from '../../../components/v2/school-new/SchoolWhatBenefit.vue';
import SchoolTariffs from '../../../components/v2/school-new/SchoolTariffs.vue';
import MainCertificate from '../../../components/v2/main/MainCertificate.vue';
import OlgaBlock from '../../../components/v2/common/OlgaBlock.vue';

export default {
  name: 'SchoolPageGumanitarnyj',
  components: {
    OlgaBlock,
    SchoolTariffs,
    GymBanner,
    SuForm,
    MainCare,
    SchoolNewBreadcrumbs,
    SchoolNewQuality,
    SchoolNewSchedule,
    SuFaq,
    MainNecessary,
    SuReviews,
    SchoolAnotherWays,
    SchoolWhatBenefit,
    MainCertificate,
  },
  mixins: [HeadMixin],
  layout: 'DefaultLayoutV2',

  data: () => ({
    breadcrumbs: [
      { text: 'главная', to: '/' },
      { text: 'домашняя школа', to: '/online-school' },
      { text: 'гуманитарный класс', to: '/online-school/gumanitarnyj' },
    ],

    // для head
    title: 'Гуманитарный класс онлайн. Онлайн-школа Синергия',
    // eslint-disable-next-line max-len,vue/max-len
    description: 'Гуманитарное направление в онлайн-школе Синергия — это возможность углубленного изучения общества, русского языка и литературы. Программа помогает развить навыки критического мышления и общения, готовя учеников к успешной карьере в социальных и гуманитарных сферах.',
    image: '/v2/school-new/gym/share-image.jpg',
  }),
};
</script>

<style scoped lang="scss">

.school-page {
  padding-top: calc(var(--scale) * 120);
  padding-bottom: calc(var(--scale) * 58);
  padding-inline: calc(var(--scale) * 40);
  background-color: #ECEDF0;
  overflow: hidden;

  display: flex;
  flex-direction: column;
  gap: calc(var(--scale) * 128);

  @include media-down($size-tablet) {
    padding-inline: calc(var(--scale) * 16);
    padding-bottom: calc(var(--scale) * 24);
    gap: calc(var(--scale) * 76);
  }

  @include media-down($size-mobile) {
    padding-inline: calc(var(--scale) * 12);
  }

  ::v-deep(*) {
    font-family: "Onest", sans-serif;
  }

  ::v-deep(.main-title) {
    position: relative;
    font-family: 'Onest', sans-serif;

    p {
      position: absolute;
      left: 0;
      top: 1.25rem;

      font-weight: 500;
      font-size: 1.625rem;
      line-height: 120%;
      color: #A7ABAC;

      @include media-down($size-tablet) {
        font-size: 1.8rem;
      }

      @include media-down($size-mobile) {
        position: relative;
        top: 0;
        margin-bottom: -0.2rem;
      }

      & + h2 {
        text-indent: calc(var(--scale) * 465);

        @include media-down($size-tablet) {
          text-indent: calc(var(--scale) * 186);
        }

        @include media-down($size-mobile) {
          text-indent: 0;
        }
      }
    }

    h2 {
      font-weight: 500;
      font-size: 5.375rem;
      line-height: 110%;
      letter-spacing: -0.04em;
      color: #02120F;

      @include media-down($size-tablet) {
        font-size: 4rem;
      }

      span {
        color: #A7ABAC;
      }
    }
  }

  .school-page__team ::v-deep(.main-title) {
    margin-bottom: calc(var(--scale) * 40);

    @include media-down($size-tablet) {
      margin-bottom: calc(var(--scale) * 24);
    }

    span {
      display: block;
    }
  }
}

</style>
